'use strict';

import React from 'react'
import ReactDOM from 'react-dom'

let PropTypes = React.PropTypes

export default React.createClass({
    propTypes:{
        name: React.PropTypes.string,
        label: React.PropTypes.string,
        value: React.PropTypes.string
    },

    getInitialState () {
        return {};
    },

    render () {
        return (
        	<div className="donate_linner_div center-block"></div>
        );
    }
});



// WEBPACK FOOTER //
// ./common/lineDiv.js